"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import Image, { type StaticImageData } from "next/image";
import faceIdle from "../../public/images/cf_face_idle.png";
import faceSleep from "../../public/images/cf_face_sleep.png";
import faceGlasses from "../../public/images/cf_face_glasses.png";
import faceConfused from "../../public/images/cf_face_confused.png";
import faceAlt from "../../public/images/cf_face_alt.png";
const FACES: StaticImageData[] = [faceIdle, faceSleep, faceGlasses, faceConfused, faceAlt];
{/* ============================================================
    MA2TIC ORG — Proprietary Software
    © 2026 MA2TIC. All Rights Reserved.
     Licensed to: MA2TIC Organisation
    Owners: Archana Thakur | Tanisha Bhardwaj |
            Manika Kutiyal | Aditya Verma
     NOTICE: This software is proprietary and confidential.
    Unauthorized copying, fragmentation, redistribution,
    or publication of this code, in whole or in part,
    is strictly prohibited without prior written permission
    from the MA2TIC development team.
     For permissions and licensing inquiries, contact MA2TIC.
    ============================================================ */}
const CYCLE_MS = 600;
export function LaunchSequence(t0) {
  const $ = _c(34);
  const {
    minDisplayMs: t1,
    readyToFade,
    onFadeComplete
  } = t0;
  const minDisplayMs = t1 === undefined ? 1600 : t1;
  const [faceIndex, setFaceIndex] = useState(0);
  const [minTimeReached, setMinTimeReached] = useState(false);
  const [fadeStarted, setFadeStarted] = useState(false);
  const [splashDone, setSplashDone] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const id = setInterval(() => {
        setFaceIndex(_temp);
      }, CYCLE_MS);
      return () => clearInterval(id);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[2] !== minDisplayMs) {
    t4 = () => {
      const t = setTimeout(() => setMinTimeReached(true), minDisplayMs);
      return () => clearTimeout(t);
    };
    t5 = [minDisplayMs];
    $[2] = minDisplayMs;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[5] !== fadeStarted || $[6] !== minTimeReached || $[7] !== readyToFade) {
    t6 = () => {
      if (!minTimeReached || fadeStarted) {
        return;
      }
      if (readyToFade === undefined || readyToFade) {
        const rafId = window.requestAnimationFrame(() => setFadeStarted(true));
        return () => window.cancelAnimationFrame(rafId);
      }
    };
    t7 = [minTimeReached, readyToFade, fadeStarted];
    $[5] = fadeStarted;
    $[6] = minTimeReached;
    $[7] = readyToFade;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  if (splashDone) {
    return null;
  }
  const t8 = `fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-10 transition-opacity duration-700 ${fadeStarted ? "opacity-0 pointer-events-none" : "opacity-100"}`;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      background: "var(--background)"
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== fadeStarted || $[12] !== onFadeComplete) {
    t10 = () => {
      if (fadeStarted) {
        setSplashDone(true);
        onFadeComplete?.();
      }
    };
    $[11] = fadeStarted;
    $[12] = onFadeComplete;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      position: "relative",
      width: 210,
      height: 210
    };
    t12 = {
      animation: "face-idle 2.8s ease-in-out infinite",
      width: "100%",
      height: "100%"
    };
    $[14] = t11;
    $[15] = t12;
  } else {
    t11 = $[14];
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      animation: "face-pop 0.42s cubic-bezier(0.34, 1.56, 0.64, 1) both",
      width: "100%",
      height: "100%"
    };
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  const t14 = FACES[faceIndex];
  const t15 = faceIndex === 0;
  const t16 = faceIndex === 0 ? "eager" : "lazy";
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      width: 210,
      height: 210,
      objectFit: "contain",
      filter: "drop-shadow(0 6px 20px rgba(0,0,0,0.18))",
      userSelect: "none"
    };
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] !== t14 || $[19] !== t15 || $[20] !== t16) {
    t18 = <Image src={t14} alt="" width={210} height={210} priority={t15} loading={t16} sizes="(max-width: 640px) 160px, 210px" quality={68} draggable={false} style={t17} />;
    $[18] = t14;
    $[19] = t15;
    $[20] = t16;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== faceIndex || $[23] !== t18) {
    t19 = <div style={t11}><div style={t12}><div key={faceIndex} style={t13}>{t18}</div></div></div>;
    $[22] = faceIndex;
    $[23] = t18;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="text-5xl font-semibold tracking-tight" style={{
      color: "var(--nt-text-hi)",
      fontFamily: "var(--font-syne), sans-serif"
    }}>cortexflow</span>;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="flex flex-col items-center gap-2">{t20}<span className="text-sm tracking-widest uppercase" style={{
        color: "var(--nt-text-lo)",
        fontFamily: "var(--font-dm-sans)"
      }}>cognitive signature analysis</span></div>;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== t19) {
    t22 = <div className="flex flex-col items-center gap-3">{t19}{t21}</div>;
    $[27] = t19;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="flex items-center gap-1.5">{[0, 1, 2].map(_temp2)}</div>;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] !== t10 || $[31] !== t22 || $[32] !== t8) {
    t24 = <div className={t8} style={t9} onTransitionEnd={t10} aria-hidden={true}>{t22}{t23}</div>;
    $[30] = t10;
    $[31] = t22;
    $[32] = t8;
    $[33] = t24;
  } else {
    t24 = $[33];
  }
  return t24;
}
function _temp2(i_0) {
  return <span key={i_0} className={`w-1.5 h-1.5 rounded-full animate-splash-dot-${i_0}`} style={{
    background: "var(--nt-text-xs)"
  }} />;
}
function _temp(i) {
  return (i + 1) % FACES.length;
}